<template>
    <div tabindex="0" @escapes="action_Close" class="pop_overlay_black v3_style">
            <div class="pop_wrap" style="width: 320px;">
                <div class="pop_title">
                    <v-icon class="red_500">mdi-alert</v-icon>
                    <b>수정 시 알림톡 심사가 필요합니다.</b>
                </div>
                <div class="pop_cont text black_500">
                    알림톡은 카카오톡 채널을 추가하지 않은 이용자에게도 발송 가능한 정보성 메시지로 정보통신망법과 카카오 내부 기준에 따라 심사가 진행되고, 카카오측에서 심사 후 승인된 알림톡 메시지만 발송 가능합니다.
                    <br><br>
                    승인이 완료되기 전까지 알림톡 전송은 불가하며, 애프터닥 앱에 가입한 고객에게만 수정된 메시지가 전달됩니다.
                    <br><br>
                    내용을 계속 수정하시려면 ‘네’ 버튼을 클릭해주세요.
                </div>
                <div class="btn_wrap w_full">
                    <button class="btn btn_s bg_red_500 w_100" @click="action_Confirm">{{ $t('common.yes') }}</button>
                    <button class="btn btn_s btn_white_line" @click="action_Close">{{ $t('common.no') }}</button>
                </div>
            </div>
    </div>
</template>


<script>
export default {
    mounted() {
        window.addEventListener('keyup', this.action_Close);
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.action_Close);
    },
    methods: {
        action_Confirm() {
            this.action_Close(undefined, true)
        },
        action_Close(_, isConfirm = false) {
            console.log('here')
            this.$emit('hideAlert', isConfirm)
        }
    },
}
</script>